import { useEffect, useState } from "react";
import { Download, Smartphone, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("siyaara_pwa_dismissed")) return;
    const ua = window.navigator.userAgent.toLowerCase();
    const isIosDevice = /iphone|ipad|ipod/.test(ua) && !window.MSStream;
    setIsIos(isIosDevice);

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem("siyaara_pwa_dismissed", "1");
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 bg-brand text-ivory p-4 rounded-2xl shadow-2xl border border-gold/40 flex items-center justify-between gap-3 animate-in slide-in-from-bottom duration-300"
      data-testid="pwa-install-banner"
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-gold/20 border border-gold flex items-center justify-center shrink-0">
          <Smartphone size={20} className="text-gold" />
        </div>
        <div>
          <p className="text-xs font-heading font-semibold text-ivory">Install Siyaara App</p>
          <p className="text-[11px] text-ivory/70">
            {isIos ? "Tap Share → Add to Home Screen" : "Live metal rates & instant tracking"}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1.5 shrink-0">
        {!isIos && deferredPrompt && (
          <Button
            size="sm"
            onClick={install}
            className="bg-gold text-brand hover:bg-white text-xs h-8 rounded-full px-3 font-semibold btn-press"
            data-testid="pwa-install-btn"
          >
            <Download size={12} className="mr-1" /> Install
          </Button>
        )}
        <button
          onClick={dismiss}
          className="text-ivory/50 hover:text-ivory p-1 rounded-full"
          aria-label="Dismiss banner"
          data-testid="pwa-dismiss-btn"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
